import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ as FAQ_DATA, COMPANY, PRIMARY_TEL } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { Phone, Mail } from "lucide-react";

export const FAQ = () => (
  <section id="faq" className="scroll-mt-24 border-t border-white/10 bg-background py-24 md:py-32">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-4">
        <Reveal>
          <Overline>Need Help?</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight text-white md:text-5xl">
            Questions, answered.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 space-y-4 border-t border-white/10 pt-8">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">Support Hotline</p>
            {COMPANY.phones.map((p) => (
              <a key={p.tel} href={`tel:${p.tel}`} data-testid={`faq-phone-${p.label.toLowerCase()}`} className="flex items-center gap-3 text-white transition-colors hover:text-primary">
                <Phone className="h-4 w-4 text-primary" />
                <span className="text-sm"><span className="text-zinc-500">{p.label}:</span> {p.number}</span>
              </a>
            ))}
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 pt-2 text-sm text-white transition-colors hover:text-primary">
              <Mail className="h-4 w-4 text-primary" /> {COMPANY.email}
            </a>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ_DATA.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-7 text-left font-serif text-xl font-light text-white hover:text-primary hover:no-underline md:text-2xl">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-7 text-sm font-light leading-relaxed text-zinc-400 md:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
